import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class CompanyModel extends BaseModel {

    constructor() {
        super({
                name: "company",
                tableName: 'company',
                label: "Công ty",
                display_key: 'name',
                default_order: { key: 'updated_at', direction: 'asc' }
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    class: "center",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                name: { 
                    name: 'name',
                    type: "String",
                    class: "center",
                    label: 'Tên công ty',
                    sortable: false,
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                },
                manager: {
                    name: 'manager',
                    type: "String",
                    class: "center",
                    label: 'Giám đốc',
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                },
                type : {
                    name: 'type',
                    type: "Selection",
                    class: "center",
                    custom: 'SelectionText',
                    label: 'Loại',
                    options: [
                        {value : "LLC" , label: "TNHH"},
                        {value : "JSC" , label : "Cổ phần"},
                        {value : "PE" , label : "Tư nhân"},
                    ],
                    filter: {
                        type: "select",
                        optionLabel: "label",
                        optionKey: "value",
                        match: "equals",
                    },
                    display: false
                },
                phone : {
                    name: 'phone',
                    type: "String",
                    class: "center",
                    label: 'Số điện thoại',
                    filter: {type: 'input', match: 'contains'},
                },
                email : {
                    name: 'email',
                    type: "String",
                    class: "center",
                    label: 'Email',
                    filter: {type: 'input', match: 'contains'},
                },
                address : { 
                    name: 'address',
                    type: "String",
                    class: "center",
                    label: 'Địa chỉ',
                    filter: {type: 'input', match: 'contains'},
                },
                active: {
                    name: "active",
                    type: "Selection", 
                    custom: 'SelectionText',
                    label: "Trạng thái",
                    class: "center",
                    options: [
                        {value : true , label: "Hoạt động"},
                        {value : false , label : "Không hoạt động"}
                    ],
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
                },
                updated_at: {
                    name: 'updated_at',
                    type: "Datetime",
                    class: "center",
                    label: 'Ngày cập nhật',
                    filter: {
                        type: "DateRange", match: "contrains",
                    },
                },
                street: {
                    name: 'street',
                    display: false
                },
                ward: {
                    refs: 'ward {id name}',
                    display: false
                },
                district: {
                    refs: 'district {id name}',
                    display: false
                },
                state: {
                    refs: 'state {id name}',
                    display: false
                },
                website: {
                    name: 'website',
                    display: false
                },
                tax_code: {
                    name: 'tax_code',
                    display: false
                },
            },
            )
    }

}